/* UNINSPIRED LP — UGC video lazy-play
   Plays MP4s only when in viewport, pauses when scrolled away. */
(function () {
  var videos = document.querySelectorAll('[data-lp-ugc-video]');
  if (!videos.length) return;

  if (!('IntersectionObserver' in window)) {
    Array.prototype.forEach.call(videos, function (v) { v.play().catch(function(){}); });
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var v = entry.target;
      if (entry.isIntersecting) {
        var p = v.play();
        if (p && typeof p.catch === 'function') p.catch(function(){});
      } else {
        v.pause();
      }
    });
  }, { threshold: 0.4 });

  Array.prototype.forEach.call(videos, function (v) { io.observe(v); });
})();
